import { useMemo } from "react";
import { getAllGames, getGameById } from "@/games/common/registry";
import type { Game } from "@/games/common/types";
import { useGamesPortalStore } from "../store/games-portal-store";

export const useGamesPortal = () => {
  const {
    isOpen,
    isCollapsed,
    isFullscreen,
    view,
    selectedGameId,
    difficulty,
    panelWidth,
    sizeMode,
    panelSide,
    sessionHud,
    openPortal,
    closePortal,
    toggleCollapsed,
    toggleFullscreen,
    setDifficulty,
    startGame,
    backToMenu,
    resetSession,
    setPanelWidth,
    setSizeMode,
    setPanelSide,
    restorePanel,
    setSessionHud,
  } = useGamesPortalStore();

  const games = useMemo(() => getAllGames(), []);

  const selectedGame = useMemo<Game | null>(() => {
    if (!selectedGameId) return null;
    return getGameById(selectedGameId) ?? null;
  }, [selectedGameId]);

  return {
    games,
    selectedGame,
    isOpen,
    isCollapsed,
    isFullscreen,
    view,
    difficulty,
    panelWidth,
    sizeMode,
    panelSide,
    sessionHud,
    openPortal,
    closePortal,
    toggleCollapsed,
    toggleFullscreen,
    setDifficulty,
    startGame,
    backToMenu,
    resetSession,
    setPanelWidth,
    setSizeMode,
    setPanelSide,
    restorePanel,
    setSessionHud,
  };
};
